import { api } from 'app/config/apiConfig';
import { CloseContractPreview, CloseContractPreviewParams } from '../model/types';

export const closeContractPreviewApi = api.injectEndpoints({
  endpoints: (builder) => ({
    closeContractPreview: builder.query<CloseContractPreview, { contractId: string; params: CloseContractPreviewParams }>({
      query: (args) => ({
        url: `/contracts/${args.contractId}/close/preview`,
        method: 'POST',
        body: args.params,
      }),
      // the modal stays mounted between openings, so a cached result would survive and could
      // show billing data that changed in the meantime - drop it as soon as nothing subscribes
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useCloseContractPreviewQuery } = closeContractPreviewApi;
